import noUiSlider from 'nouislider';
// import pmt from 'formula-pmt';
import 'nouislider/distribute/nouislider.css';
import _ from 'lodash';

const countBalance = (period, totalSum) => {
    switch (period) {
        case 6:
        case 12:
            return totalSum * (80 / 100);
        case 18:
        case 24:
            return totalSum * (70 / 100);
        case 30:
        case 36:
            return totalSum * (60 / 100);
        case 42:
        case 48:
            return totalSum * (50 / 100);
        case 54:
        case 60:
        case 66:
        case 72:
            return totalSum * (40 / 100);
    }
}

const countInterest = totalSum => {
    if (totalSum >= 40000)
        return 18;
    if (totalSum >= 30000)
        return 20;
    if (totalSum >= 20000)
        return 22;
    if (totalSum >= 10000)
        return 24;
    if (totalSum >= 8000)
        return 36;
    return 42;
}

const PMT = (rate_per_period, number_of_payments, present_value, future_value, type) => {
    future_value = typeof future_value !== 'undefined' ? future_value : 0;
    type = typeof type !== 'undefined' ? type : 0;

    if(rate_per_period != 0.0){
        // Interest rate exists
        const q = Math.pow(1 + rate_per_period, number_of_payments);
        return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)));
    }

    if(number_of_payments != 0.0){
        // No interest rate, but number of payments exists
        return -(future_value + present_value) / number_of_payments;
    }

    return 0;
};

const calculateContractFee = totalSum => {
    if (totalSum >= 80000)
        return totalSum * (1 / 100);
    if (totalSum >= 60000)
        return totalSum * (2 / 100);
    if (totalSum >= 40000)
        return totalSum * (3 / 100);
    if (totalSum >= 20000)
        return totalSum * (4 / 100);
    return totalSum * (5 / 100);
};

const calc = (sum, period) => {
    const advancePercentage = 0;
    const sumWithoutPVM = sum / 1.21;
    const totalSum = sum * ((100 - advancePercentage) / 100);
    const contractFee = calculateContractFee(totalSum);
    const balance = countBalance(period, totalSum);
    const rate = Math.round((countInterest(totalSum) / 12) * 100) / 100;
    const PMTSum = -PMT(rate / 100, period, totalSum, -balance).toFixed(0);

    return `${PMTSum} €`;
};

const debouncedSlide = _.debounce((sum, period) => {
	jQuery.post('/wp/wp-admin/admin-ajax.php', {
		action: 'getCalcResult',
		assetAmount: sum,
		periodMonths: period
	}, function (response) {
		document.getElementById('total').value = parseFloat(response.monthly_payment_amount).toFixed(2) + ' €';
	}, 'json');
}, 500);

export const calculator = () => {
	const carPriceInput = document.getElementById('car-price');
	const carRentPeriodInput = document.getElementById('car-rent-period');
	const carPriceSlider = document.getElementById('car-price-slider');
	const carRentPeriodSlider = document.getElementById('car-rent-period-slider');
	const total = document.getElementById('total');

	noUiSlider.create(carPriceSlider, {
		start: [parseInt(carPriceInput.getAttribute('data-default'))],
		step: 100,
		connect: 'lower',
		range: {
			min: parseInt(carPriceInput.getAttribute('data-min')),
			max: parseInt(carPriceInput.getAttribute('data-max')),
		},
	})

	noUiSlider.create(carRentPeriodSlider, {
		start: [parseInt(carRentPeriodInput.getAttribute('data-default'))],
		step: 12,
		connect: 'lower',
		range: {
			min: parseInt(carRentPeriodInput.getAttribute('data-min')),
			max: parseInt(carRentPeriodInput.getAttribute('data-max')),
		},
	})

	carPriceSlider.noUiSlider.on('update', function(values) {
		const formattedValue = values[0].slice(0, -3);
		carPriceInput.value = `${formattedValue} €`;
		if (formattedValue && carRentPeriodInput.value)
			debouncedSlide(parseInt(formattedValue), parseInt(carRentPeriodInput.value));
	});

	carRentPeriodSlider.noUiSlider.on('update', function(values) {
		const formattedValue = values[0].slice(0, -3);
		carRentPeriodInput.value = `${formattedValue} mėn.`;
		if (formattedValue && carPriceInput.value)
			debouncedSlide(parseInt(carPriceInput.value), parseInt(formattedValue));
	});

	carPriceInput.addEventListener('change', ({ target }) => {
		const { value } = target;
		const roundedValue = Math.round(parseInt(value)/100)*100;
		carPriceSlider.noUiSlider.set(roundedValue);
	});

	carRentPeriodInput.addEventListener('change', ({ target }) => {
		const { value } = target;
		const roundedValue = Math.round(parseInt(value));
		carRentPeriodSlider.noUiSlider.set(roundedValue);
	});

	debouncedSlide(parseInt(carPriceInput.value), parseInt(carRentPeriodInput.value));
};